import { CLEAR_RESOURCES } from 'store/resources/types'
import { CLEAR_STATUS } from 'store/ui/types'
import * as types from './types'

const initialState = {
  list: null,
}

export default function houses(state = initialState, { type, payload }) {
  switch (type) {
    case types.GET_HOUSES_SUCCESS:
      return { ...state, list: payload, error: null }
    case types.GET_HOUSES_ERROR:
      return { ...state, error: payload }
    case types.FETCH_HOUSE_SUCCESS:
      return { ...state, current: payload.house, error: null }
    case types.FETCH_HOUSE_FAILURE:
      return { ...state, error: payload.error }
    case CLEAR_RESOURCES:
      return initialState
    case CLEAR_STATUS:
      return { ...state, error: null, msg: null }
    default:
      return state
  }
}
